<template>
  <div class="groupContainer">
    <div>
      <div v-for="(group, index) in groups" :key="index+'users_group'" class="d-flex align-items-center">
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <span class="labelForSelect">{{ questionLabel }} {{ groups.length > 1 ? index + 1 : ''  }}</span>
            <a v-if="showBtnGroup && !isSelectDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group mb-1">Remove</a>
          </div>
          <FacetedSearch
            :options="facetedSearchOptions"
            @search="setFacetedFilters"
            :showOptions="true"
            :optionsToShow="formattedOptions"
            @onSelectOption="onSelectOption"
            :itemIndex="index"
            :disabled="isSelectDisabled || group.soeidNotApply === '1'"
          />
          <!-- <v-select
            v-model="group.user"
            :options="formattedOptions"
            :filterable="false"
            :multiple="false"
            :clearable="true"
            ref="selectable"
            :placeholder="$t(placeholderTranslation)"
            @search="onSearch"
            @input="onChangeSelect(index)"
            class="w-100"
            :disabled="isSelectDisabled || group.soeidNotApply === '1'"
          >
            <template #list-footer>
              <li v-if="meta.total > 10" class="pagination">
                <BButton
                  variant="outline-primary"
                  size="sm"
                  :disabled="!hasPrevPage"
                  @click="prevPage"
                >
                  <feather-icon icon="ChevronLeftIcon" size="16"/>
                </BButton>
                <BButton
                  variant="outline-primary"
                  size="sm"
                  :disabled="!hasNextPage"
                  @click="nextPage"
                >
                  <feather-icon icon="ChevronRightIcon" size="16"/>
                </BButton>
              </li>
            </template>
          </v-select> -->

          <div class="mb-1">
            <b-form-group
              class="mt-1 labelForSelect ml-1 w-50"
              label="SOEID">
              <b-form-input
                id="user_soeid"
                v-model="group.soeid"
                @input="onChange"
                :disabled="group.soeidNotApply === '1' || isSelectDisabled"
              />
            </b-form-group>
            <b-form-checkbox
              :id="uniqueId+'soeidNotApply'+index"
              v-model="group.soeidNotApply"
              name="soeidNotApply"
              value="1"
              class="text-capitalize ml-1 cursor-pointer"
              unchecked-value="0"
              @input="onChangeNotApply(index)"
              :disabled="isSelectDisabled"
            >
              {{ $t("operational_security.evaluation.does_not_apply") }}
            </b-form-checkbox>
          </div>
          <b-form-group
            class="labelForSelect ml-1 w-50"
            label="Nombre">
            <b-form-input
              id="user_name"
              v-model="group.fullName"
              @input="onChange"
              :disabled="isSelectDisabled"
            />
          </b-form-group>
          <b-form-group
            class="labelForSelect ml-1 w-50"
            label="Puesto">
            <b-form-input
              id="user_profile"
              v-model="group.profile"
              @input="onChange"
              :disabled="isSelectDisabled"
            />
          </b-form-group>
          <hr>
        </div>
      </div>
    </div>
    <button
      v-if="showBtnGroup && !isSelectDisabled"
      @click="addGroup"
      class="addGroupBtn mt-1"
      type="button" >
        <span>+ Usuario</span>
    </button>
  </div>
</template>

<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import axios from "@axios";
import {debounce} from "lodash";
import vSelect from "vue-select";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import FacetedSearch from "@/components/FacetedSearch.vue";

export default {
  components: {
    vSelect,
    FacetedSearch
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, {}) {
    const { t } = useI18nUtils();
    const entity = 'Users';
    const endpoint = '/v1/users';
    const placeholderTranslation = 'custom_forms.select_user';
    const defaultUserData = {
      user: null,
      fullName: null,
      profile: null,
      soeid: null,
      soeidNotApply: '0'
    }
    const facetedSearchOptions = [
      {
        label: t('users.search_filters.soeid'),
        value: 'user',
        isArray: false,
      },
      {
        label: t('users.search_filters.email'),
        value: 'email',
        isArray: false,
      },
      {
        label: t('users.search_filters.name'),
        value: 'name',
        isArray: false,
      },
      {
        label: t('users.search_filters.first_name'),
        value: 'first_name',
        isArray: false,
      },
      {
        label: t('users.search_filters.second_name'),
        value: 'second_name',
        isArray: false,
      },
      {
        label: t('users.search_filters.phone_number'),
        value: 'phone_number',
        isArray: false,
      },
    ];
    const exFields = props.context.attributes.extraFields
    const questionLabel = props.context.attributes.extraFields.questionLabel
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);

    // Pagination
    const search = ref('');
    const limit = ref(8);
    const currentPage = ref(1);
    const meta = ref(null);
    const options = ref([]);
    const isSelectDisabled = ref(false);
    const groups = ref([{...defaultUserData}]);
    const showBtnGroup = ref(false);
    const soeidBackup = ref([]);
    const facetedFilters = ref({});

    onMounted(async () => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      showBtnGroup.value = props?.fieldOptions?.isGroup;
      if (props?.context?.model.length) {
        setUserValues(props?.context?.model)
      }
      if(exFields?.userAnswer?.length) {
        replaceUser()
      }
      // fetchData();
    });

    function onChangeNotApply(index) {
      if(groups.value[index].soeid !== 'No aplica') {
        const soeidObj = {
          soeid: groups.value[index]?.user?.soeid,
          label: groups.value[index]?.user?.label
        }
        const exists = soeidBackup.value.some(item => item['soeid'] === soeidObj['soeid']);
        if (!exists) {
          soeidBackup.value.push(soeidObj);
        }
      }
      const soeidBackupItem = soeidBackup.value.find(item => item['label'] === groups.value[index]?.user?.label);
      groups.value[index].soeid = groups.value[index].soeidNotApply === '1' ? 'No aplica' : soeidBackupItem?.soeid
      if(groups.value[index].soeidNotApply === '1') {
        groups.value[index].user = null;
      }
      const model = getModelValue();
      props.context.model =  model.length ? model : null;
    }

    function replaceUser() {
      const data = !showBtnGroup.value && exFields.userAnswer.length > 1
      ? exFields.userAnswer.slice(0, 1)
      : exFields.userAnswer;
      const newData = data.map(obj => {
        const newObj = {};
        const firstKey = Object.keys(obj)[0];
        const oldName = firstKey.split(' [')[0];
        for (const [key, val] of Object.entries(obj)) {
          const updatedKey = key.replace(oldName, exFields.self);
          newObj[updatedKey] = val;
        }
        return newObj;
      });
      if(!newData.length) return;
      setUserValues(newData)
      props.context.model = newData
    }

    async function fetchData() {
      try {
        const {data} = await axios.get(endpoint, {
          params: {
            q: search.value,
            max: limit.value,
            'page[n]': currentPage.value,
            sortBy: 'id',
            'with[]': 'profile',
            ...facetedFilters.value
          },
        });
        meta.value = data.meta;
        options.value = data.data;
      } catch (error) {
        console.error(`${entity}Select: request error`, error?.response || error);
      }
    }

    // Computed properties
    const formattedOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.username || u.id,
        label: `${u.username} - ${u.full_name}`,
        id: u.id,
        soeid: u.username,
        fullName: u.full_name,
        profile: u.profile.type
      }))
    );

    const hasNextPage = computed(() => {
      return meta.value ? meta.value.current_page < meta.value.last_page : false;
    });

    const hasPrevPage = computed(() => {
      return meta.value ? meta.value.current_page - 1 > 0 : false;
    });

    // Watchers
    watch(currentPage, fetchData);
    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );
    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          setUserValues(newValue)
        }
      },
      { immediate: true }
    );

    // Methods
    function onChangeSelect(index) {
      let model = null;
      if(groups.value[index]?.user) {
        groups.value[index].soeid = groups.value[index].user.soeid
        groups.value[index].fullName = groups.value[index].user.fullName
        groups.value[index].profile = groups.value[index].user.profile
        model = getModelValue();
      } else {
        groups.value[index].soeid = null
        groups.value[index].fullName = null
        groups.value[index].profile = null
      }
      props.context.model =  model?.length ? model : null;
    }

    function onChange() {
      const model = getModelValue();
      props.context.model =  model.length ? model : null;
    }

    function getModelValue() {
      return groups.value.map(item => ({
        [exFields.self]: {label: item?.user?.label, value: item?.user?.value},
        [exFields.soeid]: item.soeid,
        [exFields.profile]: item.profile,
        [exFields.full_name]: item.fullName
      }));
    }

    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        currentPage.value = 1;
        await fetchData();
        loading(false);
      } else {
        currentPage.value = 1;
        search.value = '';
        await fetchData();
      }
    }, 500);

    function nextPage() {
      currentPage.value += 1;
    }

    function prevPage() {
      currentPage.value -= 1;
    }

    function addGroup() {
      groups.value.push({...defaultUserData})
      props.context.model = null
    }

    function removeGroup(index) {
      groups.value.splice(index, 1);
      const modelValue = getModelValue()
      props.context.model =  modelValue.length ? modelValue : null;
    }

    function setUserValues(data) {
      if(!data) return;
      const modelToShow = !showBtnGroup.value && data.length > 1
        ? data.slice(0, 1)
        : data;
      groups.value = modelToShow.map(item => ({
        user: {
          soeid: item[exFields.soeid] ?? null,
          fullName: item[exFields.full_name] ?? null,
          profile: item[exFields.profile] ?? null,
          ...item[exFields.self]
        },
        soeid: item[exFields.soeid] ?? null,
        fullName: item[exFields.full_name] ?? null,
        profile: item[exFields.profile] ?? null,
        soeidNotApply: item[exFields.soeid]?.toLowerCase() === 'no aplica' ? '1' : '0'
      }));
    }


    const setFacetedFilters = (filters) => {
      facetedFilters.value = {...filters, ...{advanced_search: true}}
      fetchData();
    };

    const onSelectOption = (val, index) => {
      if(!val) return;
      groups.value[index].user = val;
      onChangeSelect(index)
    };

    return {
      facetedSearchOptions,
      formattedOptions,
      meta,
      placeholderTranslation,
      isSelectDisabled,
      hasNextPage,
      hasPrevPage,
      onSearch,
      groups,
      questionLabel,
      showBtnGroup,
      uniqueId,
      nextPage,
      onChange,
      prevPage,
      addGroup,
      removeGroup,
      onChangeSelect,
      onChangeNotApply,
      setFacetedFilters,
      onSelectOption
    }
  }
}
</script>
<style scoped lang="scss">
.dark-layout {
  .labelForSelect {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.input-group-repeatable-remove {
  background-color: #cecece;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 1.35em;
  height: 1.35em;
  transition: background-color 0.2s;
}
.input-group-repeatable-remove:hover {
  background-color: #dc2c2c;
}

.input-group-repeatable-remove::before,
.input-group-repeatable-remove::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 0.80em;
  height: 0.2em;
  background-color: white;
  transform-origin: center center;
  transition: transform 0.3s ease;
}

.input-group-repeatable-remove::before {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove::after {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove:hover::before {
  top: 42%;
  transform: translateX(-60%) rotate(45deg);
}

.input-group-repeatable-remove:hover::after {
  top: 42%;
  transform: translateX(-60%) rotate(-45deg);
}
.groupContainer {
  padding: 1em;
  // border: 1px solid #efefef;
  border-radius: 0.3em;
}
</style>
